export default [
    {
        "error_id": "ST 04",
        "data": [
            {
                "cross_section": "42127",
                "type": "Culvert"
            }
        ]
    }
]